<div class="search">
  <mat-icon id="search-icon" style="margin-bottom: 15px; opacity: 0.5"
    >search</mat-icon
  >
  <app-shared-form-input-text
    #inputSearch
    id="search"
    name="search"
    [label]="label"
    [placeholder]="placeholder"
    (onChange$)="onSearch($event)"
    [autocompleteAnchor]="auto"
    [(ngModel)]="_searchString"
    [readonly]="readonly"
    (enterPress)="onEnterPress()"
  />
  <mat-autocomplete #auto="matAutocomplete">
    <mat-option
      *ngFor="let item of results || []"
      [value]="item.pii?.legal_name || item.display_name || item['Full Name']"
      (click)="onAutocompleteSelect(item)"
    >
      <ng-container [ngSwitch]="tableName">
        <ng-container *ngSwitchCase="TablesEnum.CLIENTS">
          <ng-container
            *ngTemplateOutlet="
              userPreviewTemplate;
              context: {
                $implicit: item,
                name: item.name,
              }
            "
          ></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="TablesEnum.AGENTS">
          <ng-container
            *ngTemplateOutlet="
              userPreviewTemplate;
              context: {
                $implicit: item,
                name: item.display_name,
              }
            "
          ></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="TablesEnum.PII">
          <ng-container
            *ngTemplateOutlet="piiPreviewTemplate; context: { $implicit: item }"
          ></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="TablesEnum.CASE_CLIENTS">
          <ng-container
            *ngTemplateOutlet="
              caseClientPreviewTemplate;
              context: { $implicit: item }
            "
          ></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
          {{ item.id }}
        </ng-container>
      </ng-container>
    </mat-option>
    <mat-option
      *ngIf="!!results && !results.length && !(isLoading$ | async)"
      disabled
      class="no-results-option"
    >
      <span>Not found</span>
    </mat-option>
  </mat-autocomplete>

  <ng-template #piiPreviewTemplate let-item>
    <div class="user-preview styled-preview">
      <div class="preview-row preview-main">
        <mat-icon class="preview-icon">person</mat-icon>
        <span class="preview-name">{{ item.pii?.legal_name }}</span>
        <span class="preview-dob" *ngIf="item.pii?.date_of_birth">
          ({{ item.pii?.date_of_birth | date: "dd/MM/yyyy" }})
        </span>
      </div>
      <div
        class="preview-row preview-address"
        *ngIf="
          item.pii?.primary_address?.city || item.pii?.primary_address?.country
        "
      >
        <mat-icon class="preview-icon">location_on</mat-icon>
        <span *ngIf="item.pii?.primary_address?.city">
          {{ item.pii?.primary_address?.city }}
        </span>
        <span
          *ngIf="
            item.pii?.primary_address?.city &&
            item.pii?.primary_address?.country
          "
        >
          ,
        </span>
        <span *ngIf="item.pii?.primary_address?.country">
          {{ item.pii?.primary_address?.country }}
        </span>
      </div>
      <div
        class="preview-row preview-contact"
        *ngIf="item.pii?.contacts?.email"
      >
        <mat-icon class="preview-icon">mail</mat-icon>
        <span>{{ item.pii?.contacts?.email }}</span>
      </div>
      <div
        class="preview-row preview-contact"
        *ngIf="item.pii?.contacts?.phone"
      >
        <mat-icon class="preview-icon">phone</mat-icon>
        <span>{{ item.pii?.contacts?.phone }}</span>
      </div>
      <div class="preview-row preview-id" *ngIf="item.pii?.user_id">
        <mat-icon class="preview-icon">fingerprint</mat-icon>
        <span>ID: {{ item.pii?.user_id }}</span>
      </div>
      <div class="preview-row preview-doc" *ngIf="item.pii?.id_document_value">
        <mat-icon class="preview-icon">badge</mat-icon>
        <span
          [class.highlight-blue]="item.pii?.id_document_value == _searchString"
        >
          {{ item.pii?.id_document_value }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #caseClientPreviewTemplate let-item>
    <div class="user-preview styled-preview">
      <div class="preview-row preview-main">
        <mat-icon class="preview-icon">person</mat-icon>
        <span class="preview-name">{{ item['Full Name'] }}</span>
      </div>
      <div class="preview-row preview-contact" *ngIf="item.email">
        <mat-icon class="preview-icon">mail</mat-icon>
        <span>{{ item.email }}</span>
      </div>
      <div class="preview-row preview-doc" *ngIf="item.document_digits">
        <mat-icon class="preview-icon">badge</mat-icon>
        <span [class.highlight-blue]="item.document_digits == _searchString">
          {{ item.document_digits }}
        </span>
      </div>
    </div>
  </ng-template>

  <ng-template #userPreviewTemplate let-item let-name="name">
    <div class="user-preview styled-preview">
      <div class="preview-row preview-main">
        <mat-icon class="preview-icon">person</mat-icon>
        <span class="preview-name">{{ name }}</span>
      </div>
      <div class="preview-row preview-contact" *ngIf="item.primary_email">
        <mat-icon class="preview-icon">mail</mat-icon>
        <span>{{ item.primary_email }}</span>
      </div>

      <div class="preview-row preview-id" *ngIf="item.id">
        <mat-icon class="preview-icon">fingerprint</mat-icon>
        <span>ID: {{ item.id }}</span>
      </div>
      <div class="preview-row preview-doc" *ngIf="item.document">
        <mat-icon class="preview-icon">badge</mat-icon>
        <span [class.highlight-blue]="item.document == _searchString">
          {{ item.document }}
        </span>
      </div>
    </div>
  </ng-template>

  <mat-spinner *ngIf="isLoading$ | async" diameter="14"></mat-spinner>

  <mat-icon
    *ngIf="!(isLoading$ | async) && hasSelection"
    mat-icon-button
    class="clear-selection-btn"
    (click)="clearSelection()"
    >clear</mat-icon
  >
</div>
